import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import RaceService from "../../../Services/Race.service";
const makeSearchArgs = {
    loadOptions: (search) => RaceService.searchAll(search),
    label: "name",
    value: "id",
};
export const RaceSearch = makeSearch(makeSearchArgs);
export const RaceMultiSearch = makeMultiSearch(Object.assign({}, makeSearchArgs));
